import styled from 'styled-components'
import { ArrowIcon } from '@velasca/icons/arrow'
import { ArrowRightIcon } from '@velasca/icons/arrow-right'
import { ResponsiveImage } from '@velasca/ui/responsive-image'

interface MenuPageProps {
  layout?: 'list' | 'grid'
}

export const Link = styled.a`
  color: ${({ theme }) => theme.colors.text.primary};
  &:hover,
  &:link,
  &:visited,
  &:active {
    text-decoration: none;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const MenuPageContainer = styled.div<MenuPageProps>`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

export const MenuPageLinks = styled.div`
  display: flex;
  flex-direction: column;
`

export const MenuUtilityLinks = styled.div``

export const MenuItemsLinks = styled.nav<{ layout: 'list' | 'grid' }>`
  ${({ layout, theme }) =>
    layout === 'grid'
      ? `
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 2rem;
        padding-bottom: 2rem;
        border-bottom: 1px solid ${theme.colors.secondary};
      `
      : `
        display: block;
      `}
`

export const MenuEntry = styled(Link)<
  MenuPageProps & { back?: boolean; hideBorder?: boolean }
>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ layout, back }) => layout === 'grid' && back && 'grid-column: span 2;'}
  ${({ layout, theme, back, hideBorder }) =>
    layout === 'grid'
      ? `
        flex-direction: column; 
        align-items: flex-start;
        gap: 1.5rem;
      `
      : `
        padding: ${back ? '2.25rem 0' : '1.475rem 0'};
        border-bottom: ${hideBorder ? 'none' : `1px solid ${theme.colors.secondary}`};
      `}

  &:hover,
  &:link,
  &:visited,
  &:active {
    text-decoration: none;
  }
`

export const MenuTitle = styled.span<MenuPageProps & { bold?: boolean }>`
  font-size: 1.4rem;
  font-weight: ${({ bold }) => (bold ? 600 : 400)};
  line-height: 1.25;
  letter-spacing: 0;
  ${({ layout }) => layout !== 'grid' && 'text-transform: uppercase;'}
  padding: 0.4rem 0;
  color: ${({ theme }) => theme.colors.text.primary};

  &.italic-blue {
    font-style: italic;
    color: ${({ theme }) => theme.colors.primaryLight};
  }

  &.italic {
    font-style: italic;
  }

  &.boxed {
    font-style: italic;
    color: ${({ theme }) => theme.colors.text.military500};
    outline: 1px solid ${({ theme }) => theme.colors.text.military500};
    outline-offset: -1px;
    padding: 0.4rem 2.4rem;
  }
`

export const MenuViewAllTitle = styled.span`
  font-size 1.8rem;
  font-weight: 400;
  line-height: 1.25;
  letter-spacing: 0;
  display: flex;
  align-items: center;
  gap: 1rem;
`

export const EmptyMenuEntryImage = styled.div`
  width: 100%;
  height: 100%;
`

export const MenuEntryImage = styled(ResponsiveImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  aspect-ratio: 4 / 5;
`

export const ArrowRight = styled(ArrowRightIcon)`
  width: 1rem;
  height: 1rem;
`

export const Arrow = styled(ArrowIcon)`
  width: 2rem;
  height: 2rem;
`

export const BackArrow = styled(ArrowRight)`
  transform: rotate(180deg);
`

export const Banner = styled.li`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`

export const BannerImageContainer = styled.div`
  aspect-ratio: 4 / 5;
`

export const BannerImage = styled(ResponsiveImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
`

export const BannerTitle = styled.span`
  font-size: 1.8rem;
  font-weight: 500;
  line-height: 1.25;
  letter-spacing: 0;
  text-transform: uppercase;
  text-decoration: underline;
`

export const ImageWithSkeletonContainer = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 5;
`
